import scrollama from 'scrollama'
const sharerElement = document.querySelector('.c-share');
const header = document.querySelector('.c-header');
const heroElement = document.querySelector('.c-hero')

const sharer = function () {
  const scroll = new scrollama();

  if (!sharerElement || !header || !heroElement) {
    return
  }

  scroll
    .setup({
      step: heroElement,
      offset: 0.15,
    })
    .onStepExit(res => {
      const { direction } = res;

      if (direction === 'down') {
        sharerElement.classList.add('fixed');
      }
    })
    .onStepEnter(res => {
      const { direction } = res;

      if (direction === 'up') {
        sharerElement.classList.remove('fixed');
      }
    })
}

sharer()
